import React from "react";
import PropTypes from "prop-types";
import "../styles/components/fieldset.css";

/**
 *Layout-Komponente, um andere Komponenten unter einer Überschrift in einem Rahmen zu vereinen
 *
 * @param caption die anzuzeigende Überschrift
 * @param children der Inhalt des Fieldsets
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function EAFieldset({ caption, children, ...rest }) {
    return (
        <div className="fieldset" {...rest}>
            <div className="legend">{caption}</div>
            {children}
        </div>
    );
}

EAFieldset.propTypes = {
    caption: PropTypes.node,
};

export default EAFieldset;
